export default __webpack_public_path__ + "static/media/poppins-medium.673ed423.ttf";